import { FareAPI } from '../../../api/datamanager/FareAPI';

export class FaresCommand {
    getAll(successCallback, errorCallback) {
        const apiResult = FareAPI.list();
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }
}
